import React, { useContext, useEffect } from 'react'
import { useTrans } from 'hooks'
import {
  CheckoutSidebar,
  CheckoutStepBlock,
  ListingHead,
  Page,
  ProdottiCorrelati,
} from 'components/organisms'
import styles from './CartTemplate.module.sass'
import { CartContext, initialCart } from '@utils/cartContext'
import { mockCarrello } from '@utils/mock'
import { Feedback, WContainer } from '@components/atoms'
import { PlaceholderReact, RigaCarrelloCard } from '@components/molecules'
import { useRouter } from 'next/router'
import { handleViewCartTracking } from '@utils/tracking'
import { useRecommendation } from '@hooks/useRecommendation'

interface Props {
  pagina?: any
  cartContent?: any
}

const CartTemplate = (props: Props) => {
  const { pagina = {}, cartContent = undefined } = props

  const { cart: cartContext, loading: cartLoading } = useContext(CartContext)
  const cart = process.env.STORYBOOK ? mockCarrello(1) : cartContext
  const t = useTrans()
  const router = useRouter()

  const { recommendedForYou } = useRecommendation(null)

  useEffect(() => {
    if (!cartLoading && cart !== initialCart) {
      handleViewCartTracking(cart)
    }
  }, [cart])

  const feedbackProps: {
    title?: string
    description?: string
    status?: 'success' | 'error'
  } = cart?.hasOmaggio
    ? {
        title: t('cart_has_omaggio_title'),
        description: t('cart_has_omaggio_description'),
        status: 'success',
      }
    : router.query.status === 'payment_error'
    ? {
        title: t('cart_error_during_payment'),
        description: t('cart_error_during_payment_description'),
        status: 'error',
      }
    : null

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main>
        <ListingHead pagina={pagina} />
        {cart.items?.length ? (
          <WContainer>
            <div className={styles.layout}>
              <div className={styles.main}>
                {feedbackProps && <Feedback {...feedbackProps} />}
                <CheckoutStepBlock
                  title={t('Carrello')}
                  status="open"
                  className={styles.cartBlock}
                  hideHeadMobile
                >
                  <div className={styles.list}>
                    {cart.items.map((rigaCarrello) => (
                      <RigaCarrelloCard key={rigaCarrello.pk} rigaCarrello={rigaCarrello} />
                    ))}
                  </div>
                </CheckoutStepBlock>
                <PlaceholderReact
                  contentTypeId={pagina.model}
                  objectId={pagina.pk}
                  pkey={'cartContent'}
                  serverSideContent={cartContent}
                />
              </div>
              <aside className={styles.sidebar}>
                <CheckoutSidebar dati={cart} variant="cart" />
              </aside>
            </div>
          </WContainer>
        ) : (
          <div className={styles.emptyLayout}>
            <WContainer>
              <div className={styles.emptyContent}>
                <h2 className={styles.emptyTitle}>{t('Il tuo carrello è vuoto')}</h2>
                <div
                  className={styles.emptyDescription}
                  dangerouslySetInnerHTML={{
                    __html: t('empty_cart_description'),
                  }}
                />
              </div>
            </WContainer>
            <ProdottiCorrelati prodotti={recommendedForYou} className={styles.correlati} />
          </div>
        )}
      </main>
    </Page>
  )
}

export default CartTemplate
